import React from 'react';
import Lottie from 'react-lottie';
import './Home_Loan_Lottie.css';
import * as animationData from './Home_Loan_Lottie.json';

function Home_Loan_Lottie() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    return (
        <section className='main'>
            <div className='Home_Loan_Lottie_icon'>
                <Lottie className="me-auto"
                    options={defaultOptions}
                />
            </div>
        </section>
    );
}
export default Home_Loan_Lottie;